import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const useImageGeneration = () => {
  const { toast } = useToast();
  const [generatedImage, setGeneratedImage] = useState<string | null>(null);
  const [isGeneratingImage, setIsGeneratingImage] = useState(false);

  const handleGenerateImage = async (drillText: string) => {
    if (!drillText.trim()) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Please enter drill text before generating an image.",
      });
      return;
    }

    setIsGeneratingImage(true);
    try {
      console.log('Sending drill text:', drillText);
      const { data, error } = await supabase.functions.invoke('generate-drill-image', {
        body: { drillText }
      });

      if (error) throw error;

      if (data?.success && data?.image) {
        console.log('Image generated successfully');
        setGeneratedImage(data.image);
        toast({
          title: "Success",
          description: "Image generated successfully!",
        });
      } else {
        throw new Error(data?.error || "Failed to generate image");
      }
    } catch (error: any) {
      console.error('Image generation error:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to generate image. Please try again.",
      });
    } finally {
      setIsGeneratingImage(false);
    }
  };

  return {
    generatedImage,
    setGeneratedImage,
    isGeneratingImage,
    handleGenerateImage,
  };
};